export default __webpack_public_path__ + "images/NT.0612069.png";